import { useTranslation } from "react-i18next"
import { ReceiptTaxIcon } from "@heroicons/react/outline"
import { SupplierInvoiceFiles } from "../ReplenishmentBoxes/SupplierInvoiceFiles"

const I18N_BASE = "replenishments.show_replenishment_boxes.supplier_invoice"

// Replenishment-level factura summary: each entered number with its total
// received count as plain text — deliberately NOT the segmented ×N pill, which
// belongs to the received-pieces table's per-row FACTURAS column. Facturas
// nothing was received against are hidden: they're usually mis-entered numbers
// and would only add noise. Renders nothing when empty so flag-off /
// factura-less replenishments stay clean.
export const FacturaList = ({ invoices }) => {
  const { i18n } = useTranslation()
  const received = (invoices || []).filter(({ quantity }) => quantity > 0)
  if (received.length === 0) return null
  return (
    <section className="bg-white rounded-lg shadow-sm p-5 mb-4">
      <h3 className="font-bold text-lg flex items-center gap-2">
        <ReceiptTaxIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" aria-hidden="true" />
        {i18n.t(`${I18N_BASE}.column_header`)}
      </h3>
      <ul className="mt-2 space-y-1">
        {received.map(({ invoice_number, quantity }) => (
          <li key={invoice_number} className="flex items-baseline gap-3">
            <span className="font-mono font-semibold text-sm text-emerald-800">{invoice_number}</span>
            <span className="text-gray-500 text-sm">
              {i18n.t(`${I18N_BASE}.pieces_received`, { count: quantity })}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}

// The facturas + document bucket (upload/list/delete) pair for the post-check-in
// views: two separate cards, matching the page's stacked-card layout. FacturaList
// brings its own card (and disappears when empty); the documents section gets one here.
export const SupplierInvoiceSection = ({ replenishmentId, invoices }) => (
  <>
    <FacturaList invoices={invoices} />
    <div className="bg-white rounded-lg shadow-sm mb-4">
      <SupplierInvoiceFiles replenishmentId={replenishmentId} />
    </div>
  </>
)
